// src/components/home/HomeSkeleton.js
// Squelette de chargement animé pour la page d'accueil - NE PAS MODIFIER

import React from 'react';
import { useTheme } from '../../hooks/useTheme';

const HomeSkeleton = () => {
  const { theme } = useTheme();

  const shimmerBase = theme.mode === 'light' ? '#EDEFEC' : '#1A2436';
  const shimmerHighlight = theme.mode === 'light' ? '#F7F9F7' : '#243247';

  const styles = {
    container: { display: 'flex', flexDirection: 'column', backgroundColor: theme.bg },
    block: (width, height, radius = '8px') => ({
      width,
      height,
      borderRadius: radius,
      background: `linear-gradient(90deg, ${shimmerBase} 25%, ${shimmerHighlight} 50%, ${shimmerBase} 75%)`,
      backgroundSize: '200% 100%',
      animation: 'fynhoShimmer 1.6s ease-in-out infinite',
    }),
    header: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '16px' },
    headerLeft: { display: 'flex', alignItems: 'center', gap: '10px' },
    searchArea: { padding: '0 16px 16px' },
    categoryRow: { display: 'flex', justifyContent: 'space-around', padding: '16px' },
    categoryItem: { display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '8px' },
    section: { paddingTop: '20px' },
    sectionHeader: { display: 'flex', justifyContent: 'space-between', padding: '0 16px', marginBottom: '12px' },
    cardRow: { display: 'flex', gap: '12px', padding: '0 16px', overflow: 'hidden' },
    card: { display: 'flex', flexDirection: 'column', gap: '8px', width: '200px', flexShrink: 0 },
  };

  return (
    <div style={styles.container}>
      <style>{`
        @keyframes fynhoShimmer {
          0% { background-position: 200% 0; }
          100% { background-position: -200% 0; }
        }
      `}</style>

      {/* Header */}
      <div style={styles.header}>
        <div style={styles.headerLeft}>
          <div style={styles.block('40px', '40px', '10px')} />
          <div style={styles.block('80px', '18px')} />
        </div>
        <div style={styles.headerLeft}>
          <div style={styles.block('36px', '36px', '50%')} />
          <div style={styles.block('64px', '32px', '20px')} />
        </div>
      </div>

      {/* Barre de recherche */}
      <div style={styles.searchArea}>
        <div style={styles.block('100%', '48px', '14px')} />
      </div>

      {/* Bouton géolocalisation */}
      <div style={styles.searchArea}>
        <div style={styles.block('100%', '52px', '12px')} />
      </div>

      {/* Catégories */}
      <div style={styles.categoryRow}>
        {[1, 2, 3, 4].map((i) => (
          <div key={i} style={styles.categoryItem}>
            <div style={styles.block('40px', '40px', '50%')} />
            <div style={styles.block('50px', '10px')} />
          </div>
        ))}
      </div>

      {/* Rangées d'annonces (x3) */}
      {[1, 2, 3].map((section) => (
        <div key={section} style={styles.section}>
          <div style={styles.sectionHeader}>
            <div>
              <div style={{ ...styles.block('140px', '18px'), marginBottom: '6px' }} />
              <div style={styles.block('180px', '12px')} />
            </div>
          </div>
          <div style={styles.cardRow}>
            {[1, 2, 3].map((card) => (
              <div key={card} style={styles.card}>
                <div style={styles.block('200px', '130px', '12px')} />
                <div style={styles.block('160px', '14px')} />
                <div style={styles.block('120px', '12px')} />
                <div style={styles.block('80px', '14px')} />
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default HomeSkeleton;